import { Component } from '@angular/core';
import { NavItemComponent } from '../nav-item/nav-item.component';
import { Router, RouterModule } from '@angular/router';
import { AuthenticationManagerOperation } from '../../../shared/operations/auth/authentication-manager.operation';
import { AuthApiService } from '../../../core/services/auth.api.service';
import { UserState } from '../../../core/states/user-state';
import { BrowserStorageService } from '../../../core/services/browser-storage.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
    standalone: true,
    imports: [NavItemComponent, RouterModule]
})
export class MainComponent {
    authenticationManager: AuthenticationManagerOperation;
    showMenu: boolean = false;

    constructor(
        private router: Router,
        private authService: AuthApiService,
        private userState: UserState,
        private browserStorageService: BrowserStorageService
    ) {
        this.authenticationManager = new AuthenticationManagerOperation(authService, userState, router, browserStorageService);
    }

    get isAdmin(): boolean {
        const user = this.userState.getUser();
        return !!(user?.privilegeLevels?.some((p: { name?: string }) =>
            p?.name === 'Admin' || (typeof p?.name === 'string' && p.name.endsWith('Admin'))
        ));
    }

    /** Shown next to Logout; prefer full name, fall back to email. */
    get displayName(): string {
        const user = this.userState.getUser();
        if (!user) return '';
        const name = user.fullName?.trim();
        return name || user.email || '';
    }

    /** Tooltip when name and email differ so the full identity is discoverable. */
    get accountTooltip(): string {
        const user = this.userState.getUser();
        if (!user?.email) return '';
        const name = user.fullName?.trim();
        if (name && user.email && name !== user.email) {
            return `${name} (${user.email})`;
        }
        return user.email;
    }

    applicationListClick = () => {
        this.showMenu = false;
        this.router.navigate(['/loan/application-list']);
    }

    inviteAdminClick = () => {
        this.showMenu = false;
        this.router.navigate(['/invite-admin']);
    }

    usersClick = () => {
        this.showMenu = false;
        this.router.navigate(['/users']);
    }

    homeClick = () => {
        this.showMenu = false;
        this.authenticationManager.logout();
        this.router.navigate(['/login']);
    }

    toggleMenu = () => {
        this.showMenu = !this.showMenu;
    }
}
